import React, { Suspense } from 'react';
import 'typeface-inter';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import i18n configuration
import './i18n';
import { CircularProgress, Box } from '@mui/material';

// Loading component to show while translations are being loaded
const LoadingComponent = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress />
  </Box>
);

// Hide Google Maps LoadScript default "Loading..." indicator
// The LoadScript component from @react-google-maps/api may inject a loading indicator
// We hide it by observing DOM changes and removing/hiding any "Loading" text divs
const hideGoogleMapsLoadingIndicator = () => {
  const observer = new MutationObserver(() => {
    // Look for divs with "Loading" text that are absolutely positioned at top-left
    const allDivs = document.querySelectorAll('body > div:not(#root)');
    allDivs.forEach((div) => {
      const text = (div.textContent || '').trim();
      if (text === 'Loading' || text === 'Loading...') {
        const style = window.getComputedStyle(div);
        // Only hide if it's positioned at top-left (where LoadScript places it)
        if (style.position === 'absolute' && 
            (parseFloat(style.top || '0') < 50 && parseFloat(style.left || '0') < 50)) {
          (div as HTMLElement).style.display = 'none';
          (div as HTMLElement).style.visibility = 'hidden';
          (div as HTMLElement).style.opacity = '0';
        }
      }
    });
  });

  // Start observing immediately and continue for a few seconds
  observer.observe(document.body, {
    childList: true,
    subtree: false, // Only watch direct children of body
  });

  // Stop observing after 5 seconds (maps should be loaded by then)
  setTimeout(() => {
    observer.disconnect();
  }, 5000);
};

// Run immediately and also on DOM ready
hideGoogleMapsLoadingIndicator();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideGoogleMapsLoadingIndicator);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingComponent />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
